import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const walletUserLogout = http.delete(
  createMockEndpoint('/wallet_user/:id/logout'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
